var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { span: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              !_vm.isBahia && !_vm.isProcessoFisico
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouPossuiCar
                        ? "text"
                        : "",
                    attrs: {
                      label: "Possui CAR?",
                      content:
                        _vm.imovel.possuiCar ||
                        ((_vm.isAmapa || _vm.isPara) && _vm.isOneroso)
                          ? "Sim"
                          : "Não"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm.imovel.possuiConflitoAgrario !== null &&
          !_vm.isBahia &&
          !_vm.isPara &&
          !_vm.isProcessoFisico &&
          !_vm.isAmapa
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouConflitos
                        ? "text"
                        : "",
                    attrs: {
                      label: "Possui conflito fundiário?",
                      content: _vm.imovel.possuiConflitoAgrario ? "Sim" : "Não"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.imovel.numeroReciboCar
                ? _c("app-display", {
                    class:
                      _vm.compararImovel &&
                      _vm.compararImovel.mudouNumeroReciboCar
                        ? "text"
                        : "",
                    attrs: {
                      label: _vm.labelImovel.numeroRecibo,
                      content: _vm.quebraLinha(_vm.imovel.numeroReciboCar),
                      isContentInNextLine: true,
                      marginBottom: true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm.imovel.descricao
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Descrição:",
                      content: _vm.imovel.descricao
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isBahia
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Comunidade:",
                      content: _vm.imovel.comunidade || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Denominação do Imóvel:",
                      content: _vm.imovel.denominacao || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Gleba:", content: _vm.imovel.gleba || "-" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showNomeNucleo
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do núcleo:",
                      content: _vm.imovel.nomeNucleo || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Localização:",
                      content: _vm.imovel.localizacao || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Latitude:",
                      content: _vm.imovel.latitude || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "UF localização da sede:",
                      content: _vm.imovel.ufLocalizacaoSede || "MA"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Longitude:",
                      content: _vm.imovel.longitude || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Logradouro:",
                      content: _vm.imovel.logradouro || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: !_vm.isProcessoFisico
                        ? "Bairro:"
                        : "Bairro/Localização:",
                      content: _vm.imovel.bairro || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Número:",
                      content: _vm.imovel.numero || "-"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.imovel.nome
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouNome
                        ? "text"
                        : "",
                    attrs: {
                      label: "Nome do Imóvel:",
                      content: _vm.imovel.nome
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.isBahia
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouNome
                        ? "text"
                        : "",
                    attrs: {
                      label: "Código do Imóvel:",
                      content: _vm.imovel.codigoImovel || "-"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.hasMunicipio && (!_vm.isMaranhao() || _vm.isProcessoFisico)
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouMunicipio
                        ? "text"
                        : "",
                    attrs: {
                      label: "Município:",
                      content: _vm.imovel.municipio.nome || "-"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.hasMunicipio && !_vm.isMaranhao()
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouEstadoImovel
                        ? "text"
                        : "",
                    attrs: {
                      label: "UF:",
                      content: _vm.imovel.municipio.estado || "-"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.imovel.area && !_vm.isProcessoFisico
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      label: "Área:",
                      content:
                        _vm.formatterDecimal(_vm.imovel.area) + " hectare(s)"
                    }
                  })
                : _vm._e(),
              _vm.isProcessoFisico
                ? _c("app-display", {
                    class:
                      _vm.compararImovel && _vm.compararImovel.mudouArea
                        ? "text"
                        : "",
                    attrs: {
                      label: "Área:",
                      content:
                        _vm.formatterDecimal(_vm.imovel.area) +
                        " " +
                        _vm.getTipoArea(_vm.imovel.tipoArea)
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.imovel.finalidades && _vm.imovel.finalidades.length > 0
                ? _c("app-display", {
                    class:
                      _vm.compararImovel &&
                      _vm.compararImovel.mudouFinalidadesImovel
                        ? "text"
                        : "",
                    attrs: {
                      label: "Finalidades:",
                      content: _vm.getFinalidades(_vm.imovel.finalidades)
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.imovel.descricaoAcesso
                ? _c("app-display", {
                    class:
                      _vm.compararImovel &&
                      _vm.compararImovel.mudouDescricaoAcesso
                        ? "text"
                        : "",
                    attrs: {
                      label: "Descrição de acesso:",
                      content: _vm.imovel.descricaoAcesso
                    }
                  })
                : _vm._e(),
              _vm.imovel.possuiImovel &&
              !_vm.imovel.possuiCar &&
              !_vm.isOnerosoGroup &&
              !_vm.isBahia
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.imovel.possuiImovel !== null
                        ? _c("app-display", {
                            class:
                              _vm.compararImovel &&
                              _vm.compararImovel.mudouPossuiImovel
                                ? "text"
                                : "",
                            attrs: {
                              label:
                                "Possui outros imóveis rurais em território nacional?",
                              content: _vm.imovel.possuiImovel ? "Sim" : "Não"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAmapa
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.imovel.possuiImoveisTerritorioNacional !== null
                        ? _c("app-display", {
                            class:
                              _vm.compararImovel &&
                              _vm.compararImovel.mudouPossuiImovel
                                ? "text"
                                : "",
                            attrs: {
                              label:
                                "Possui outros imóveis rurais em território nacional?",
                              content: _vm.imovel
                                .possuiImoveisTerritorioNacional
                                ? "Sim"
                                : "Não"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          ((_vm.imovel.ocupantesAnteriores && !_vm.imovel.possuiCar) ||
            _vm.isOnerosoGroup) &&
          !_vm.isBahia
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.imovel.ocupantesAnteriores !== null
                    ? _c("app-display", {
                        class:
                          _vm.compararImovel &&
                          _vm.compararImovel.mudouOcupantesAnteriores
                            ? "text"
                            : "",
                        attrs: {
                          label: "Há ocupantes anteriores?",
                          content: _vm.imovel.ocupantesAnteriores
                            ? "Sim"
                            : "Não"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          (_vm.imovel.ocupantesAnteriores && !_vm.imovel.possuiCar) ||
          _vm.isOnerosoGroup
            ? _c(
                "div",
                [
                  _vm.isOneroso && !_vm.isAmapa
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.imovel.possuiImovel != null
                            ? _c("app-display", {
                                class:
                                  _vm.compararImovel &&
                                  _vm.compararImovel.mudouPossuiImovel
                                    ? "text"
                                    : "",
                                attrs: {
                                  label: _vm.labelImovel.possuiImovel,
                                  content: _vm.imovel.possuiImovel
                                    ? "Sim"
                                    : "Não"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  ((_vm.imovel.ocupantesAnteriores && !_vm.imovel.possuiCar) ||
                    _vm.isOnerosoGroup) &&
                  !_vm.isBahia
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _vm.imovel.conflitos != null
                                ? _c("app-display", {
                                    class:
                                      _vm.compararImovel &&
                                      _vm.compararImovel.mudouConflitos
                                        ? "text"
                                        : "",
                                    attrs: {
                                      label: "Há conflitos no imóvel?",
                                      content: _vm.imovel.conflitos
                                        ? "Sim"
                                        : "Não"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _vm.imovel.numeroProcessoJudicial
                                ? _c("app-display", {
                                    class:
                                      _vm.compararImovel &&
                                      _vm.compararImovel
                                        .mudouNumeroProcessoJudicial
                                        ? "text"
                                        : "",
                                    attrs: {
                                      label: "Número do processo judicial:",
                                      content: _vm.imovel.numeroProcessoJudicial
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _vm.imovel.nomeTempoOcupacao != null
                                ? _c("app-display", {
                                    attrs: {
                                      label: "Tempo de ocupação:",
                                      content: _vm.imovel.nomeTempoOcupacao
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _vm.imovel.tempoOcupacao != null
                                ? _c("app-display", {
                                    class:
                                      _vm.compararImovel &&
                                      _vm.compararImovel.mudouTempoOcupacao
                                        ? "text"
                                        : "",
                                    attrs: {
                                      label: "Tempo de ocupação:",
                                      content: _vm.getUnidadeAno(
                                        _vm.imovel.tempoOcupacao
                                      )
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.isBahia
        ? _c(
            "div",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.imovel.idTipoOcupacao
                    ? _c("app-display", {
                        attrs: {
                          label: "Tipo de ocupação:",
                          content:
                            _vm.imovel.idTipoOcupacao === "3"
                              ? _vm.imovel.outroTipoOcupacao
                              : _vm.imovel.tipoOcupacao.label
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data de ocupação:",
                      content: _vm.formataDataHora(_vm.imovel.dataOcupacao)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Possui outra propriedade rural?",
                      content: _vm.imovel.possuiOutraPropriedadeRural
                        ? "Sim"
                        : "Não"
                    }
                  })
                ],
                1
              ),
              _c("informacoes-atividades", {
                attrs: {
                  destinacaoUsoImovel: _vm.destinacaoUsoImovel,
                  compararDestinacaoUsoImovel: _vm.compararDestinacaoUsoImovel
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.imovel.endereco
        ? _c(
            "app-divider",
            { attrs: { label: "Endereço do imóvel" } },
            [
              _c("informacoes-endereco", {
                staticClass: "margin-top",
                attrs: {
                  slot: "body",
                  endereco: _vm.enderecoImovel,
                  mudouEndereco: false
                },
                slot: "body"
              })
            ],
            1
          )
        : _vm._e(),
      _vm.cadastroOriginal.tipo === "CERTIDAO_TITULO"
        ? _c(
            "app-collapse",
            { attrs: { title: "Matrícula" } },
            [
              _c(
                "el-row",
                [
                  _vm.imovel.cnsMatricula
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararImovel &&
                              _vm.compararImovel.mudouCNSMatricula
                                ? "text"
                                : "",
                            attrs: {
                              label: "CNS:",
                              content: _vm.imovel.cnsMatricula
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.imovel.numeroMatricula
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararImovel &&
                              _vm.compararImovel.mudouNumeroMatricula
                                ? "text"
                                : "",
                            attrs: {
                              label: "Número:",
                              content: _vm.imovel.numeroMatricula
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.imovel.livroMatricula
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararImovel &&
                              _vm.compararImovel.mudouLivroMatricula
                                ? "text"
                                : "",
                            attrs: {
                              label: "Livro:",
                              content: _vm.imovel.livroMatricula
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.imovel.numeroFolhaMatricula
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            class:
                              _vm.compararImovel &&
                              _vm.compararImovel.mudouNumeroFolhaMatricula
                                ? "text"
                                : "",
                            attrs: {
                              label: "N° da folha:",
                              content: _vm.imovel.numeroFolhaMatricula
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.cadastroOriginal.tipo === "CERTIDAO_TITULO"
        ? _c(
            "app-collapse",
            { attrs: { title: "Dados do Título" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class:
                          _vm.compararImovel &&
                          _vm.compararImovel.mudouNumeroFolhaMatricula
                            ? "text"
                            : "",
                        attrs: {
                          label: "Nome do beneficiário:",
                          content: _vm.imovel.nomeBeneficiarioTitulo
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararImovel &&
                          _vm.compararImovel.mudouNomeBeneficiarioTitulo
                            ? "text"
                            : "",
                        attrs: {
                          label: "N° do título:",
                          content: _vm.imovel.numeroTitulo
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararImovel &&
                          _vm.compararImovel.mudouAreaTitulo
                            ? "text"
                            : "",
                        attrs: {
                          label: "Área:",
                          content:
                            _vm.formatterDecimal(_vm.imovel.areaTitulo) +
                            " hectare(s)"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        class:
                          _vm.compararImovel &&
                          _vm.compararImovel.mudouDataExpedicaoTitulo
                            ? "text"
                            : "",
                        attrs: {
                          label: "Data de expedição:",
                          content: _vm.getDate(_vm.imovel.dataExpedicaoTitulo)
                        }
                      }),
                      _c("app-display", {
                        class:
                          _vm.compararImovel &&
                          _vm.compararImovel.mudouModalidadeTitulo
                            ? "text"
                            : "",
                        attrs: {
                          label: "Modalidade:",
                          content: _vm.formatModalidade(
                            _vm.imovel.modalidadeTitulo
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5182cf80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5182cf80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesImovel.vue
// module id = null
// module chunks = 